export default "__VITE_ASSET__BUt3YCSl__"